import { createSelector } from 'reselect'
import { getLargeDevicesBreakPoint, getMediumDevicesBreakPoint } from 'redux/configuration/selectors'

export const getVisualizer = state => state.visualizer

export const getVisualizerSize = createSelector(
    getVisualizer,
    visualizer => visualizer.size
)

export const getVisualizerWidth = createSelector(
    getVisualizerSize,
    size => size.width
)

export const isVisualizerSmallerThanLargeDevice = createSelector(
    getVisualizerWidth,
    getLargeDevicesBreakPoint,
    (visualizerWidth, largeDevicesBreakPoint) => visualizerWidth < largeDevicesBreakPoint
)

export const isVisualizerSmallerThanMediumDevice = createSelector(
    getVisualizerWidth,
    getMediumDevicesBreakPoint,
    (visualizerWidth, mediumDevicesBreakPoint) => visualizerWidth < mediumDevicesBreakPoint
)

export const isResponsiveModeEnabled = createSelector(
    isVisualizerSmallerThanLargeDevice,
    isVisualizerSmallerThanDevice => isVisualizerSmallerThanDevice
)

export const isListeningKeyboardEventsEnabled = createSelector(
    getVisualizer,
    visualizer => visualizer.listeningKeyboardEvents
)
